// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e3989b74","239":"1a4debea","455":"fbd406c9"}[chunkId] + ".chunk.js";
};